import { REQUESTS_FEED_BASE_API_URL } from './constants';

export type GetRequestsFeedApiRouteParams = {
  tab?: string;
  locationId?: string;
  cursor?: string;
  limit?: number;
};

export type ApproveRejectAndUpdateAvailabilityParams = {
  templateId: string;
  status?: 'approved' | 'rejected';
};

export type MarkTabViewedApiRouteParams = {
  tab: 'my';
  locationId?: string;
};

// ============================================================================
// Requests Feed API
// ============================================================================

export const getRequestsFeedApiRoute = ({
  tab = 'my',
  locationId,
  cursor,
  limit = 20,
}: GetRequestsFeedApiRouteParams) => {
  const params = [`tab=${tab}`, `limit=${limit}`];
  if (locationId) {
    params.push(`location_id=${locationId}`);
  }
  if (cursor) {
    params.push(`cursor=${cursor}`);
  }
  return `${REQUESTS_FEED_BASE_API_URL}?${params.join('&')}`;
};

export const markTabViewedApiRoute = () =>
  `${REQUESTS_FEED_BASE_API_URL}/mark_tab_viewed`;

// ============================================================================
// Availability API
// ============================================================================

export const approveRejectAndUpdateAvailabilityApiRoute = ({
  templateId,
}: ApproveRejectAndUpdateAvailabilityParams) =>
  `/availability_templates/${templateId}`;

export const deleteAvailabilityTemplateApiRoute = (templateId: string) =>
  `/availability_templates/${templateId}`;

// ============================================================================
// Trade/Cover Requests API
// ============================================================================

export const getRequestDetailsApiRoute = (
  requestId: string,
  tab: string = 'my'
) => `${REQUESTS_FEED_BASE_API_URL}/${requestId}?tab=${tab}`;

export const getCoverRequestDetailsApiRoute = (requestId: string) =>
  `/covers/${requestId}/review_details`;

export const approveTradeCoverRequestApiRoute = (requestId: string) =>
  `/trades/${requestId}/approve`;

export const rejectTradeCoverRequestApiRoute = (requestId: string) =>
  `/trades/${requestId}/reject`;

export const acceptTradeCoverRequestApiRoute = (requestId: string) =>
  `/trades/${requestId}/accept`;

// ============================================================================
// Time Off Requests API
// ============================================================================

export const getTimeOffRequestDetailsApiRoute = (requestId: string) =>
  `/time_offs/${requestId}`;

export const approveTimeOffRequestApiRoute = (requestId: string) =>
  `/time_offs/${requestId}/approve`;

export const rejectTimeOffRequestApiRoute = (requestId: string) =>
  `/time_offs/${requestId}/reject`;

export const deleteTimeOffRequestApiRoute = (requestId: string) =>
  `/time_offs/${requestId}`;

// ============================================================================
// Open Shifts API
// ============================================================================

export const getOpenShiftDetailsApiRoute = (requestId: string) =>
  `/shifts/${requestId}`;

export const approveClaimRequestApiRoute = (requestId: string) =>
  `/schedule_builder/claim_requests/${requestId}/approve`;
